module.exports = __webpack_public_path__ + "images/verify-certificate-mobile.jpg";